import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M2 1.25a.75.75 0 0 1 .743.648L2.75 2l-.001.119h10.337c.378 0 .726.168.981.45l.092.11c.226.302.345.687.345 1.08v1.7c0 .393-.12.777-.345 1.078-.26.348-.647.56-1.072.56H2.749v1.326h10.337c.378 0 .726.169.981.45l.092.111c.226.301.345.687.345 1.08v1.699c0 .393-.12.778-.345 1.079-.26.347-.647.56-1.072.56H2.749v1.108h15.54c.378 0 .725.169.981.45l.091.111c.227.301.346.686.346 1.08v1.699c0 .866-.58 1.64-1.417 1.64l-15.541-.001.001 1.326h18.815a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.648.743l-.102.007H2a.75.75 0 0 1-.743-.648l-.007-.102V2A.75.75 0 0 1 2 1.25zm16.181 14.76H2.75v1.979h15.54c-.084 0-.086-.016-.084-.089v-1.75a.43.43 0 0 0-.006-.075l-.019-.065zm-5.202-6.087H2.749v1.979h10.23a.302.302 0 0 0 .019-.065l.006-.074v-1.7a.432.432 0 0 0-.006-.075l-.019-.065zm0-6.304H2.749v1.978h10.23a.286.286 0 0 0 .019-.064l.006-.074v-1.7a.432.432 0 0 0-.006-.075l-.019-.065z' />
  </svg>
);
